
function cartEvents() {

  const {
    freeGwpProductIdTier1,
    freeGwpProductTier1InStock,
    freeGwpThresholdTier1,
    freeGwpThresholdTier2,
    freeGwpProductIdTier2,
    freeGwpProductTier2InStock,
    gwpSectionThreshold,
    gwpMaxItems,
  } = ACDC.Data;

  let gwpAbortController = null;
  let cleanupRunning = false;

  function abortStaleGwpOps() {
    if (gwpAbortController) gwpAbortController.abort();
    gwpAbortController = new AbortController();
    return gwpAbortController.signal;
  }

  const gwpSectionProductsContainer = document.querySelector('.gwp-section-products-container');
  const gwpSectionProducts = gwpSectionProductsContainer ? gwpSectionProductsContainer.getAttribute('data-gwp-product-ids') : '';
  const gwpProductArray = gwpSectionProducts ? gwpSectionProducts.split('-') : [];

  init();

  function init() {
    addEvents();
  }

  function gwpNeedsUpdate(totalCartPrice, cartItems) {
    const price = Number(totalCartPrice);
    const itemIds = cartItems.map((item) => item.id);

    if (freeGwpProductIdTier1 != "" && freeGwpThresholdTier1 != "") {
      const hasTier1 = itemIds.includes(Number(freeGwpProductIdTier1));
      const aboveTier1 = price >= Number(freeGwpThresholdTier1);
      if (aboveTier1 && !hasTier1 && freeGwpProductTier1InStock) return true;
      if (!aboveTier1 && hasTier1) return true;
    }

    if (freeGwpProductIdTier2 != "" && freeGwpThresholdTier2 != "") {
      const hasTier2 = itemIds.includes(Number(freeGwpProductIdTier2));
      const aboveTier2 = price >= Number(freeGwpThresholdTier2);
      if (aboveTier2 && !hasTier2 && freeGwpProductTier2InStock) return true;
      if (!aboveTier2 && hasTier2) return true;
    }

    if (gwpSectionThreshold && gwpSectionThreshold != "" && price < Number(gwpSectionThreshold)) {
      for (const gwpProductId of gwpProductArray) {
        if (itemIds.includes(parseInt(gwpProductId))) return true;
      }
      if (cartItems.some(item => item.properties && item.properties._gwp === "true")) return true;
    }

    return false;
  }

  // Batched GWP sync — computes all adds/removes from cart data, executes in max 2 API calls
  async function processGwpSync(cartData, signal) {
    const totalCartPrice = Number(cartData.total_price);
    const cartItems = cartData.items;
    const itemIds = cartItems.map(item => item.id);

    const itemsToAdd = [];
    const updates = {};

    // Tier 1
    if (freeGwpProductIdTier1 != "" && freeGwpThresholdTier1 != "") {
      const tier1Id = Number(freeGwpProductIdTier1);
      const hasTier1 = itemIds.includes(tier1Id);
      if (totalCartPrice >= Number(freeGwpThresholdTier1) && !hasTier1 && freeGwpProductTier1InStock) {
        itemsToAdd.push({ quantity: 1, id: tier1Id });
      } else if (totalCartPrice < Number(freeGwpThresholdTier1) && hasTier1) {
        updates[tier1Id] = 0;
      }
    }

    // Tier 2
    if (freeGwpProductIdTier2 != "" && freeGwpThresholdTier2 != "") {
      const tier2Id = Number(freeGwpProductIdTier2);
      const hasTier2 = itemIds.includes(tier2Id);
      if (totalCartPrice >= Number(freeGwpThresholdTier2) && !hasTier2 && freeGwpProductTier2InStock) {
        itemsToAdd.push({ quantity: 1, id: tier2Id });
      } else if (totalCartPrice < Number(freeGwpThresholdTier2) && hasTier2) {
        updates[tier2Id] = 0;
      }
    }

    // GWP section items — remove if below threshold
    if (gwpSectionThreshold && gwpSectionThreshold != "" && totalCartPrice < Number(gwpSectionThreshold)) {
      cartItems.forEach(item => {
        if (item.properties && item.properties._gwp === "true") {
          updates[item.id] = 0;
        }
      });
    }

    let cartChanged = false;

    if (itemsToAdd.length > 0) {
      if (signal.aborted) return;
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToAdd }),
        signal: signal,
      });
      cartChanged = true;
    }

    if (Object.keys(updates).length > 0) {
      if (signal.aborted) return;
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ updates: updates }),
        signal: signal,
      });
      cartChanged = true;
    }

    if (cartChanged) {
      if (window.themeVariables.settings.pageType === "cart") {
        await refreshCartPage();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      }
    }
  }

  // Guarded cleanup for stale GWP items — batch removal in single API call
  async function cleanupStaleGwpItems(cartDataOverride) {
    if (!gwpSectionThreshold || gwpSectionThreshold === '') return;
    if (cleanupRunning) return;
    cleanupRunning = true;

    try {
      const cart = cartDataOverride || await (await fetch('/cart.js')).json();
      if (Number(cart.total_price) >= Number(gwpSectionThreshold)) return;

      const updates = {};
      cart.items.forEach(item => {
        if (item.properties && item.properties._gwp === 'true') {
          updates[item.id] = 0;
        }
      });

      if (Object.keys(updates).length === 0) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ updates: updates }),
      });

      if (window.themeVariables.settings.pageType === 'cart') {
        await refreshCartPage();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } finally {
      cleanupRunning = false;
    }
  }

  // Section Rendering API refresh for cart page — no full page reload
  async function refreshCartPage() {
    const cartSection = document.querySelector('.shopify-section[id*="main-cart"]');
    if (!cartSection) {
      window.location.reload();
      return;
    }
    const sectionId = cartSection.id.replace('shopify-section-', '');

    try {
      const response = await fetch(Shopify.routes.root + '?section_id=' + sectionId);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newSection = doc.getElementById(cartSection.id);
      if (newSection) {
        cartSection.innerHTML = newSection.innerHTML;
      } else {
        window.location.reload();
      }
    } catch (e) {
      window.location.reload();
    }
  }

  // Initial cart state check
  fetch("/cart.js")
    .then((resp) => resp.json())
    .then((json) => {
      const totalCartPrice = json.total_price;
      const cartItems = json.items;
      toggleGwpSection(totalCartPrice);
      handleGWPCartActions(cartItems);

      if (window.themeVariables.settings.pageType === "cart") {
        if (gwpNeedsUpdate(totalCartPrice, cartItems)) {
          const signal = abortStaleGwpOps();
          processGwpSync(json, signal).catch(function(err) {
            if (err.name !== 'AbortError') console.error('[GWP]', err);
          });
        } else {
          cleanupStaleGwpItems(json);
        }
      }
    });

  function addEvents() {
    // cart:refresh — toggle visibility + sync buttons (debounced).
    // On the cart page the line-item table/totals are server-rendered, so a GWP
    // add (ajaxAddToCart) won't show until the section is re-rendered. Reuse
    // refreshCartPage() here, then rebind the carousel arrows and re-sync state.
    let refreshDebounceTimer = null;
    document.addEventListener('cart:refresh', function() {
      clearTimeout(refreshDebounceTimer);
      refreshDebounceTimer = setTimeout(async function() {
        if (window.themeVariables.settings.pageType === "cart") {
          await refreshCartPage();
          initGwpCarouselArrows();
        }
        fetch("/cart.js")
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            toggleGwpSection(cart.total_price);
            handleGWPCartActions(cart.items);
          });
      }, 300);
    });

    // cart:change — use event.detail.cart directly, no extra /cart.js fetch
    document.addEventListener('cart:change', function(event) {
      const signal = abortStaleGwpOps();
      const cartData = event.detail && event.detail.cart;

      if (cartData) {
        toggleGwpSection(cartData.total_price);
        processGwpSync(cartData, signal).catch(function(err) {
          if (err.name !== 'AbortError') console.error('[GWP]', err);
        });
      } else {
        fetch("/cart.js", { signal: signal })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            toggleGwpSection(cart.total_price);
            processGwpSync(cart, signal);
          })
          .catch(function(err) {
            if (err.name !== 'AbortError') console.error('[GWP]', err);
          });
      }
    });
  }

  function toggleGwpSection(totalCartPrice) {
    if (gwpSectionThreshold) {
      // Multiple instances can coexist (cart drawer + cart page), so toggle each.
      const gwpSections = document.querySelectorAll(".minicart-gwp-wrap");
      gwpSections.forEach(function(gwpSection) {
        gwpSection.style.removeProperty('display');
        if (
          gwpSectionThreshold != "" &&
          Number(totalCartPrice) >= Number(gwpSectionThreshold)
        ) {
          gwpSection.classList.add("gwp-visible");
        } else {
          gwpSection.classList.remove("gwp-visible");
        }
      });
    }
  }

  // Override prev/next button state for GWP carousel.
  // Re-callable so the cart page can rebind after refreshCartPage() replaces the DOM.
  function initGwpCarouselArrows() {
    // Multiple instances can coexist (cart drawer + cart page); bind each one.
    const gwpSections = document.querySelectorAll('.minicart-gwp-wrap');
    gwpSections.forEach(function(gwpSection) {
      const carousel = gwpSection.querySelector('scroll-carousel');
      const prevBtn = gwpSection.querySelector('carousel-prev-button button');
      const nextBtn = gwpSection.querySelector('carousel-next-button button');
      if (!carousel || !prevBtn || !nextBtn) return;

      // Avoid duplicate listeners when rebound after a DOM replacement.
      if (carousel.dataset.arrowsBound === 'true') return;
      carousel.dataset.arrowsBound = 'true';

      carousel.addEventListener('scroll', function() {
        const scrollLeft = Math.round(Math.abs(carousel.scrollLeft));
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;

        prevBtn.disabled = scrollLeft <= 0;
        nextBtn.disabled = scrollLeft >= maxScroll - 1;
      });
    });
  }
  initGwpCarouselArrows();

  function handleGWPCartActions(cartItems) {
    let gwpItemCount = 0;
    const maxGwpItems = gwpMaxItems ? parseInt(gwpMaxItems) : 1;
    const gwpForms = document.querySelectorAll('.minicart-gwp-form');

    gwpForms.forEach(form => {
      const variantId = form.querySelector('input[name="id"]').value;
      const isInCart = cartItems.some((item) => item.id == parseInt(variantId) && item.properties && item.properties._gwp === "true");
      if (isInCart) {
        gwpItemCount++;
        form.querySelector('.atb-ajax-plp').innerText = 'Added';
        form.querySelector('.add-to-cart').setAttribute('disabled', true);
      }
    });

    if (gwpItemCount >= maxGwpItems) {
      gwpForms.forEach(form => {
        form.querySelector('.add-to-cart').setAttribute('disabled', true);
      });
    } else {
      gwpForms.forEach(form => {
        const variantId = form.querySelector('input[name="id"]').value;
        const isInCart = cartItems.some((item) => item.id == parseInt(variantId) && item.properties && item.properties._gwp === "true");
        if (!isInCart) {
          form.querySelector('.add-to-cart').removeAttribute('disabled');
          form.querySelector('.atb-ajax-plp').innerText = 'Add';
        }
      });
    }
  }

  window.syncGwpButtonStates = handleGWPCartActions;
}

window.addEventListener("DOMContentLoaded", () => {
  cartEvents();
});


function ajaxAddToCart(event) {
    event.preventDefault();

    const id = event.target.querySelector('input[name="id"]').value;

    const allGwpButtons = document.querySelectorAll('.minicart-gwp-form .add-to-cart');
    allGwpButtons.forEach(btn => btn.setAttribute('disabled', true));

    event.target.querySelector('.atb-ajax-plp').innerText = 'Loading...';

    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        const alreadyGwp = cart.items.some(
          item => item.id == parseInt(id) && item.properties && item.properties._gwp === "true"
        );
        if (alreadyGwp) {
          event.target.querySelector('.atb-ajax-plp').innerText = 'Added';
          return;
        }
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{ quantity: 1, id: parseInt(id), properties: { "_gwp": "true" } }]
          }),
        })
        .then(r => r.json())
        .then(() => {
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        });
      });
  }
